import { useToken } from "../../../../Hooks/useToken"
import { PublicLinkLoggedOut } from "../publicLinkLoggedOut";

const PublicLinkRequiresLogin = (props: any) => {
   const userIsLogged = useToken()

   return userIsLogged ? props.component : <PublicLinkLoggedOut />
};

export default PublicLinkRequiresLogin;